import React from 'react';

const colorMap = {
  cyan: 'ds-badge--cyan',
  green: 'ds-badge--green',
  purple: 'ds-badge--purple',
  amber: 'ds-badge--amber',
  red: 'ds-badge--red',
  blue: 'ds-badge--blue',
  gray: 'ds-badge--gray',
};

export default function DSBadge({
  children,
  color = 'cyan',
  dot = false,
  className = '',
  ...props
}) {
  const cls = [
    'ds-badge',
    colorMap[color] || colorMap.cyan,
    className,
  ].filter(Boolean).join(' ');

  return (
    <span className={cls} {...props}>
      {dot && <span className="ds-badge__dot" />}
      {children}
    </span>
  );
}
